class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);

      dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          currency: "USD",
          value: this.getAttribute("data-price"),
          items: [
            {
              item_id: this.getAttribute("data-sku"),
              item_name: this.getAttribute("data-itemTitle").toLowerCase(),
              currency: "USD",
              discounted_price: this.getAttribute("data-discount") > 0 ? "yes" : "no",
              discount: this.getAttribute("data-discount"),
              item_brand: this.getAttribute("data-vendor").replace(" US", ""),
              item_category: this.getAttribute("data-type"),
              item_variant: this.getAttribute("data-variantTitle"),
              price: this.getAttribute("data-price"),
              quantity: 0,
            },
          ],
        },
      });
      return false;
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]'),
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    let removeSampleElement = document.querySelector(
      "[data-free-sample-remove]",
    );
    if (
      typeof removeSampleElement != "undefined" &&
      removeSampleElement != null
    ) {
      var getSampleIds = removeSampleElement.getAttribute(
        "data-free-sample-remove",
      );
      if (removeSampleElement.hasAttribute("data-drawer")) {
        this.removeSampleProducts(getSampleIds, "drawer");
      } else {
        this.removeSampleProducts(getSampleIds, "cart");
      }
    }

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    let freeSampleEle = document.querySelectorAll(".free-sample-atc");
    freeSampleEle.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        if (btn.hasAttribute("data-cart-page")) {
          this.freeSampleATC(event, "cart");
        } else {
          this.freeSampleATC(event, "drawer");
        }
      });
    });

    let freeGiftEle = document.querySelectorAll(".gift-wrap-product");
    freeGiftEle.forEach((btn) => {
      btn.addEventListener("change", (event) => {
        if (btn.hasAttribute("data-cart-page")) {
          this.giftingATC(event, "cart");
        } else {
          this.giftingATC(event, "drawer");
        }
      });
    });
  }

  disableAllFreeSampleATC() {
    try {
      document
        .querySelectorAll(".free-sample-atc")
        .forEach((ele) => ele.classList.add("disabled-element"));
    } catch (ex) {
      console.warn(ex);
    }
  }

  onChange(event) {
    if (event.target.classList.contains("quantity__input")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
      );
    }
  }
  // onChange(event) {
  //   if(event.target.classList.contains('quantity__input')){
  //       this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  //   }
  //   else{
  //       setTimeout(function() {
  //           if (typeof window.addKlarnaToMiniCart === 'function') addKlarnaToMiniCart(0);
  //           if (typeof window.addKlarna === 'function') addKlarna(0);
  //       }, 1000);
  //   }
  // }

  bindEvent() {
    let freeSampleEle = document.querySelectorAll(".free-sample-atc");
    freeSampleEle.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        if (btn.hasAttribute("data-cart-page")) {
          this.freeSampleATC(event, "cart");
        } else {
          // this.freeSampleATC(event,'drawer');
        }
      });
    });

    let freeGiftEle = document.querySelectorAll(".gift-wrap-product");
    freeGiftEle.forEach((btn) => {
      btn.addEventListener("change", (event) => {
        if (btn.hasAttribute("data-cart-page")) {
          this.giftingATC(event, "cart");
        } else {
          this.giftingATC(event, "drawer");
        }
      });
    });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".cart-parent",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    var _this = this;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        parsedState.items.forEach(function (response, index) {
          var count = index + 1;
          var item_brand =
            response.product_type == "Nudeskin" ? "Nudeskin" : "Nudestix";
          if (count == parseInt(line)) {
            if (name == "plus") {
              dataLayer.push({
                event: "add_to_cart_v2",
                ecommerce: {
                  currency: "USD",
                  value: response.price / 100,
                  items: [
                    {
                      item_id: response.sku,
                      item_name: response.title.toLowerCase(),
                      currency: "USD",
                      discounted_price: response.total_discount > 0 ? "yes" : "no",
                      discount: response.total_discount,
                      item_brand: item_brand,
                      item_category: response.product_type,
                      item_variant: response.variant_title,
                      price: response.price / 100,
                      quantity: response.quantity,
                    },
                  ],
                },
              });
            } else {
              dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                  currency: "USD",
                  value: response.price / 100,
                  items: [
                    {
                      item_id: response.sku,
                      item_name: response.title.toLowerCase(),
                      currency: "USD",
                      discounted_price: response.total_discount > 0 ? "yes" : "no",
                      discount: response.total_discount,
                      item_brand: item_brand,
                      item_category: response.product_type,
                      item_variant: response.variant_title,
                      price: response.price / 100,
                      quantity: response.quantity,
                    },
                  ],
                },
              });
            }
          }
        });
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0,
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );

          var parser = new DOMParser();
          var doc = parser.parseFromString(
            parsedState.sections[section.section],
            "text/html",
          );
          // console.log('section',section);

          let removeSampleElement = doc.querySelector(
            "[data-free-sample-remove]",
          );
          if (
            typeof removeSampleElement != "undefined" &&
            removeSampleElement != null
          ) {
            var getSampleIds = removeSampleElement.getAttribute(
              "data-free-sample-remove",
            );
            if (section.id == "CartDrawer") {
              this.removeSampleProducts(getSampleIds, "drawer");
            } else if (section.id == "main-cart-items") {
              this.removeSampleProducts(getSampleIds, "cart");
            }
          }
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`),
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a"),
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name"),
          );
        }
        this.disableLoading();
        window.loyaltylion && window.loyaltylion.ui.refresh();

        var getEle = document.querySelector(".free-cart");
        if (typeof getEle != "undefined" && getEle != null) {
          var swiper = new Swiper(getEle, {
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 15,
            autoplayDisableOnInteraction: true,
            pagination: true,
            grabCursor: true,
            allowTouchMove: true,
            slideToClickedSlide: true,
            navigation: {
              nextEl: ".free-sample-slider-next",
              prevEl: ".free-sample-slider-prev",
            },
            breakpoints: {
              0: {
                allowTouchMove: true,
                slideToClickedSlide: true,
                slidesPerView: "auto",
              },
              500: {
                allowTouchMove: true,
                slideToClickedSlide: true,
                slidesPerView: 2,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
              1100: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            },
          });
        }

        var getEle1 = document.querySelector(".free-drawer");
        if (typeof getEle1 != "undefined" && getEle1 != null) {
          var swiper = new Swiper(getEle1, {
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 15,
            autoplayDisableOnInteraction: true,
            pagination: true,
            grabCursor: true,
            allowTouchMove: true,
            slideToClickedSlide: true,
            navigation: {
              nextEl: ".free-sample-slider-next",
              prevEl: ".free-sample-slider-prev",
            },
            breakpoints: {
              0: {
                allowTouchMove: true,
                slideToClickedSlide: true,
                slidesPerView: "auto",
              },
              576: {
                allowTouchMove: true,
                slideToClickedSlide: true,
                slidesPerView: 3,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
              1100: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            },
          });
        }

        var getswap = document.querySelector("[data-swipe-ele]");
        if (typeof getswap != "undefined" && getswap != null) {
          if (getswap.hasAttribute("data-cart-page")) {
            setTimeout(function () {
              _this.swapProduct(getswap, "cart");
            }, 400);
          } else {
            setTimeout(function () {
              _this.swapProduct(getswap, "drawer");
            }, 400);
          }
        }

        var getswaprev = document.querySelector("[data-swipe-ele-rev]");
        if (typeof getswaprev != "undefined" && getswaprev != null) {
          if (getswaprev.hasAttribute("data-cart-page")) {
            setTimeout(function () {
              _this.swapProduct(getswaprev, "cart");
            }, 400);
          } else {
            setTimeout(function () {
              _this.swapProduct(getswaprev, "drawer");
            }, 400);
          }
        }
        this.bindEvent();
        setTimeout(function () {
          if (typeof window.addKlarnaToMiniCart === "function")
            addKlarnaToMiniCart((parsedState.total_price / 100 / 4).toFixed(2));
          if (typeof window.addKlarna === "function")
            addKlarna((parsedState.total_price / 100 / 4).toFixed(2));
        }, 1000);
      })
      .catch((error) => {
        console.log("file: cart.js:403 | CartItems | .then | error:", error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        // const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  freeSampleATC(event, page) {
    event.preventDefault();
    this.disableAllFreeSampleATC();
    var varID = event.target.getAttribute("data-var");
    if (page == "cart") {
      var URL = "/cart";
    } else {
      var URL = "/";
    }
    var addData = {
      id: Number(varID),
      quantity: 1,
    };
    event.target
      .querySelector(".loading-overlay__spinner")
      .classList.remove("hidden");
    fetch("/cart/add.js", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch(URL, {
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          method: "GET",
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(state, "text/html");
            document.getElementById("main-cart-items").innerHTML =
              doc.getElementById("main-cart-items").innerHTML;
            var getEle = document.querySelector(".free-cart");
            window.loyaltylion && window.loyaltylion.ui.refresh();
            if (typeof getEle != "undefined" && getEle != null) {
              var swiper = new Swiper(getEle, {
                loop: false,
                slidesPerView: "auto",
                spaceBetween: 15,
                autoplayDisableOnInteraction: true,
                pagination: true,
                grabCursor: true,
                allowTouchMove: true,
                slideToClickedSlide: true,
                navigation: {
                  nextEl: ".free-sample-slider-next",
                  prevEl: ".free-sample-slider-prev",
                },
                breakpoints: {
                  0: {
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    slidesPerView: "auto",
                  },
                  500: {
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                  1100: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                },
              });
            }

            var getEle1 = document.querySelector(".free-drawer");
            if (typeof getEle1 != "undefined" && getEle1 != null) {
              var swiper = new Swiper(getEle1, {
                loop: false,
                slidesPerView: "auto",
                spaceBetween: 15,
                autoplayDisableOnInteraction: true,
                pagination: true,
                grabCursor: true,
                allowTouchMove: true,
                slideToClickedSlide: true,
                navigation: {
                  nextEl: ".free-sample-slider-next",
                  prevEl: ".free-sample-slider-prev",
                },
                breakpoints: {
                  0: {
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    slidesPerView: "auto",
                  },
                  576: {
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                  1100: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                },
              });
            }
            this.bindEvent();
          })
          .catch(() => {});
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        // const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // errors.textContent = window.cartStrings.error;
      });
  }

  giftingATC(event, page) {
    console.log("file: cart.js:551 | CartItems | giftingATC | page:", page);
    console.log("file: cart.js:551 | CartItems | giftingATC | event:", event);
    event.preventDefault();
    console.log("ghfghhg");
    var varID = event.target.getAttribute("data-var-id");
    if (page == "cart") {
      var URL = "/cart";
    } else {
      var URL = "/";
    }
    var addData = {
      id: Number(varID),
      quantity: 1,
      properties: {
        product_type: "giftwrapproduct",
      },
    };
    // event.target.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    fetch("/cart/add.js", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch(URL, {
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          method: "GET",
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(state, "text/html");
            document.getElementById("main-cart-items").innerHTML =
              doc.getElementById("main-cart-items").innerHTML;
            var getEle = document.querySelector(".free-cart");
            window.loyaltylion && window.loyaltylion.ui.refresh();
            if (typeof getEle != "undefined" && getEle != null) {
              var swiper = new Swiper(getEle, {
                loop: false,
                slidesPerView: "auto",
                spaceBetween: 15,
                autoplayDisableOnInteraction: true,
                pagination: true,
                grabCursor: true,
                allowTouchMove: true,
                slideToClickedSlide: true,
                navigation: {
                  nextEl: ".free-sample-slider-next",
                  prevEl: ".free-sample-slider-prev",
                },
                breakpoints: {
                  0: {
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    slidesPerView: "auto",
                  },
                  500: {
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                  1100: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                },
              });
            }

            var getEle1 = document.querySelector(".free-drawer");
            if (typeof getEle1 != "undefined" && getEle1 != null) {
              var swiper = new Swiper(getEle1, {
                loop: false,
                slidesPerView: "auto",
                spaceBetween: 15,
                autoplayDisableOnInteraction: true,
                pagination: true,
                grabCursor: true,
                allowTouchMove: true,
                slideToClickedSlide: true,
                navigation: {
                  nextEl: ".free-sample-slider-next",
                  prevEl: ".free-sample-slider-prev",
                },
                breakpoints: {
                  0: {
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    slidesPerView: "auto",
                  },
                  576: {
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                  1100: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                },
              });
            }
            this.bindEvent();
          })
          .catch(() => {});
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        // const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // errors.textContent = window.cartStrings.error;
      });
  }

  swapProduct(event, page) {
    var varremoveID = event.getAttribute("data-gift-id");
    var varaddID = event.getAttribute("data-free-gift-id");

    if (page == "cart") {
      var URL = "/cart";
    } else {
      var URL = "/";
    }
    var removeData = {
      id: varremoveID,
      quantity: 0,
    };

    var addData = {
      id: Number(varaddID),
      quantity: 1,
      properties: {
        product_type: "giftwrapproduct",
      },
    };
    // event.target.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    fetch("/cart/change.js", {
      body: JSON.stringify(removeData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart/add.js", {
          body: JSON.stringify(addData),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          method: "POST",
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            fetch(URL, {
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "xmlhttprequest",
              },
              method: "GET",
            })
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                var parser = new DOMParser();
                var doc = parser.parseFromString(state, "text/html");
                document.getElementById("main-cart-items").innerHTML =
                  doc.getElementById("main-cart-items").innerHTML;
                var getEle = document.querySelector(".free-cart");
                window.loyaltylion && window.loyaltylion.ui.refresh();
                if (typeof getEle != "undefined" && getEle != null) {
                  var swiper = new Swiper(getEle, {
                    loop: false,
                    slidesPerView: "auto",
                    spaceBetween: 15,
                    autoplayDisableOnInteraction: true,
                    pagination: true,
                    grabCursor: true,
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    navigation: {
                      nextEl: ".free-sample-slider-next",
                      prevEl: ".free-sample-slider-prev",
                    },
                    breakpoints: {
                      0: {
                        allowTouchMove: true,
                        slideToClickedSlide: true,
                        slidesPerView: "auto",
                      },
                      500: {
                        allowTouchMove: true,
                        slideToClickedSlide: true,
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      992: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                      },
                      1100: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                      },
                    },
                  });
                }

                var getEle1 = document.querySelector(".free-drawer");
                if (typeof getEle1 != "undefined" && getEle1 != null) {
                  var swiper = new Swiper(getEle1, {
                    loop: false,
                    slidesPerView: "auto",
                    spaceBetween: 15,
                    autoplayDisableOnInteraction: true,
                    pagination: true,
                    grabCursor: true,
                    allowTouchMove: true,
                    slideToClickedSlide: true,
                    navigation: {
                      nextEl: ".free-sample-slider-next",
                      prevEl: ".free-sample-slider-prev",
                    },
                    breakpoints: {
                      0: {
                        allowTouchMove: true,
                        slideToClickedSlide: true,
                        slidesPerView: "auto",
                      },
                      576: {
                        allowTouchMove: true,
                        slideToClickedSlide: true,
                        slidesPerView: 3,
                        spaceBetween: 20,
                      },
                      992: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                      },
                      1100: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                      },
                    },
                  });
                }
                this.bindEvent();
              })
              .catch((err) => {
                console.log("error", err);
              });
          })
          .catch((err) => {
            console.log("error", err);
          });
      })
      .catch((err) => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        // const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // errors.textContent = window.cartStrings.error;
        console.log("error", err);
      });
  }

  removeSampleProducts(ids, page) {
    var varArray = ids.split(",");
    var data = {};

    if (page == "cart") {
      var URL = "/cart";
    } else {
      var URL = "/";
    }

    // return false;

    for (let index = 0; index < varArray.length; ++index) {
      data[varArray[index]] = 0;

      if (index == varArray.length - 1) {
        const result = fetch("/cart/update.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ updates: data }),
        }).then((response) => {
          fetch(URL, {
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            method: "GET",
          })
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              var parser = new DOMParser();
              var doc = parser.parseFromString(state, "text/html");
              // document.getElementById('main-cart-items').innerHTML = doc.getElementById('main-cart-items').innerHTML;
              let mainCartItems = document.getElementById("main-cart-items");
              mainCartItems.classList.add("is-empty");
              mainCartItems.innerHTML =
                doc.getElementById("main-cart-items").innerHTML;
              document.getElementById("cart-icon-bubble").innerHTML =
                doc.getElementById("cart-icon-bubble").innerHTML;

              var getEle = document.querySelector(".free-cart");
              window.loyaltylion && window.loyaltylion.ui.refresh();
              if (typeof getEle != "undefined" && getEle != null) {
                var swiper = new Swiper(getEle, {
                  loop: false,
                  slidesPerView: "auto",
                  spaceBetween: 15,
                  autoplayDisableOnInteraction: true,
                  pagination: true,
                  grabCursor: true,
                  allowTouchMove: true,
                  slideToClickedSlide: true,
                  navigation: {
                    nextEl: ".free-sample-slider-next",
                    prevEl: ".free-sample-slider-prev",
                  },
                  breakpoints: {
                    0: {
                      allowTouchMove: true,
                      slideToClickedSlide: true,
                      slidesPerView: "auto",
                    },
                    500: {
                      allowTouchMove: true,
                      slideToClickedSlide: true,
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 24,
                    },
                    1100: {
                      slidesPerView: 3,
                      spaceBetween: 24,
                    },
                  },
                });
              }

              var getEle1 = document.querySelector(".free-drawer");
              if (typeof getEle1 != "undefined" && getEle1 != null) {
                var swiper = new Swiper(getEle1, {
                  loop: false,
                  slidesPerView: "auto",
                  spaceBetween: 15,
                  autoplayDisableOnInteraction: true,
                  pagination: true,
                  grabCursor: true,
                  allowTouchMove: true,
                  slideToClickedSlide: true,
                  navigation: {
                    nextEl: ".free-sample-slider-next",
                    prevEl: ".free-sample-slider-prev",
                  },
                  breakpoints: {
                    0: {
                      allowTouchMove: true,
                      slideToClickedSlide: true,
                      slidesPerView: "auto",
                    },
                    576: {
                      allowTouchMove: true,
                      slideToClickedSlide: true,
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 24,
                    },
                    1100: {
                      slidesPerView: 3,
                      spaceBetween: 24,
                    },
                  },
                });
              }
              this.bindEvent();
            })
            .catch(() => {});
        });
      }
    }
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      // lineItemError
      //   .querySelector('.cart-item__error-text')
      //   .innerHTML = window.cartStrings.quantityError.replace(
      //     '[quantity]',
      //     quantityElement.value
      //   );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300),
        );
      }
    },
  );
}
